import $ from "jquery";
import objectFitImages from "object-fit-images";

$(function () {
    // Adds support for 'object-fit: cover;'.
    objectFitImages();
});
